import { endpoints } from "@/config/endpoints";
import { apiService } from "@/services/apiService";

const prepareRequestData = ({ page, perPage }) => {
  return {
    page: page || 1,
    page_size: perPage || 10,
    auto_reply_status: 1
  };
};

export default {
  getReviews(data) {
    const params = prepareRequestData(data);
    return apiService.get(endpoints.autoReplies.reviews, {
      params
    });
  },
  acceptReply(payload) {
    return apiService.post(endpoints.autoReplies.accept, payload);
  },
  rejectReply(payload) {
    return apiService.post(endpoints.autoReplies.reject, payload);
  }
};
